import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import SalesKpi from './sales';
import PartWatchingList from './partWatching/list';
import PartWatching from './partWatching/view';
import ReceivedAndDispatchedLinesKpi from './cpd';

export const kpisRoutes = [
  {'component': <SalesKpi />, 'path': paths.SalesKpi},
  {'component': <PartWatchingList />, 'path': paths.PartWatchingList},
  {'component': <PartWatching />, 'path': paths.PartWatchingKpi},
  {
    'component': <ReceivedAndDispatchedLinesKpi />,
    'path': paths.ReceivedAndDispatchedLinesKpi,
  },
];
